import { Container, Flex, Heading, Image, Text } from '@chakra-ui/react';

import workingChicken from '../../assets/gif/working-chicken.gif';
function Home() {
  return (
    <Container maxW='container.lg'>
      <Flex
        minH='calc(100vh - 10rem)'
        flexDirection='column'
        alignItems='center'
        justifyContent='center'
        gap={10}
      >
        <Heading textAlign='center'>Under Construction</Heading>
        <Image src={workingChicken} alt='working-chicken' />
        <Text>we will back soon</Text>
      </Flex>
    </Container>
  );
}

export default Home;
